/* eslint-disable @typescript-eslint/no-unused-vars */
import { Authenticated, CustomRoutes, Resource } from 'react-admin'
import { Route } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import auth from './resources/auth'

// Theme, Auth & Data
import theme from './themes'
import CustomLayout from './layouts'

import initAuthProvider from './providers/auth'
import initDataProvider from './providers/data'
import { i18nProvider } from './providers/localization'
// Resources
import UserProfile from './resources/auth/UserProfile'
import adminResource from './resources/admins'
import rolesPermissionsResource from './resources/roles-permissions'
import emailConfigResource from './resources/email-config'
import servicesResource from './resources/services'

// Icons
import AssignmentInd from '@mui/icons-material/AssignmentIndRounded'
import LockPersonIcon from '@mui/icons-material/LockPerson'
// import NewspaperIcon from '@mui/icons-material/NewspaperRounded'
import CategoryIcon from '@mui/icons-material/CategoryRounded'
// import PodcastsIcon from '@mui/icons-material/PodcastsRounded'
// import UpdateIcon from '@mui/icons-material/Update'
// import SourceRoundedIcon from '@mui/icons-material/SourceRounded'
// import Star from '@mui/icons-material/Star'

import { RbacAdmin } from './components/ra-rbac'
import { createBrowserHistory as createHistory } from 'history'
import GlobalStyles from './themes/styles/globalStyles'
import Dashboard from './resources/dashboard'
import branchConfigResource from './resources/branch-config'
import bookingViewResource from './resources/bookingview'
import BookingResource from './resources/booking'
import temperaryRequestResource from './resources/temporary-request'

const App = (): JSX.Element => {
  const authProvider = initAuthProvider()
  const dataProvider = initDataProvider()
  const history = createHistory()
  return (
    <>
      <CssBaseline />
      <GlobalStyles />
      <RbacAdmin
        theme={theme}
        loginPage={auth.login}
        layout={CustomLayout}
        dashboard={Dashboard}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        history={history}
        disableTelemetry
      >
        <Resource
          name='admins'
          options={{ label: 'Admin Management' }}
          icon={AssignmentInd}
          {...adminResource}
        />
        <Resource
          name='roles'
          options={{ label: 'Roles & Permissions' }}
          icon={LockPersonIcon}
          {...rolesPermissionsResource}
        />
        <Resource
          name='emailconfig'
          options={{ label: 'Email Config', isGlobalSearch: true }}
          {...emailConfigResource}
        />
        <Resource
          name='branch_config'
          options={{ label: 'Branch Config' }}
          icon={LockPersonIcon}
          {...branchConfigResource}
        />
        <Resource
          name='services'
          options={{ label: 'Services Management' }}
          icon={CategoryIcon}
          {...servicesResource}
        />
        <Resource
          name='booking-view'
          options={{ label: 'Booking View', isGlobalSearch: true }}
          {...bookingViewResource}
        />
        <Resource
          name='temporary-request'
          options={{ label: 'Temporary Request', isGlobalSearch: true }}
          {...temperaryRequestResource}
        />
        <CustomRoutes>
          <Route
            path='/profile/'
            element={
              <Authenticated requireAuth>
                <UserProfile />
              </Authenticated>
            }
          />
        </CustomRoutes>
        <CustomRoutes>
          <Route
            path='/booking'
            element={
              <Authenticated requireAuth>
                <BookingResource />
              </Authenticated>
            }
          />
        </CustomRoutes>
        {/* <CustomRoutes noLayout>

        </CustomRoutes> */}
      </RbacAdmin>
    </>
  )
}

export default App
